module.exports = __webpack_public_path__ + "files/34d5e7cd1a0210b7d65955128c2e5a34.png";